import type { ElementType } from 'react';

let components: Record<string, ElementType> = {};

export function getAvailableComponents(): Record<string, ElementType> {
  return components;
}

export function setAvailableComponents(c: Record<string, ElementType>): void {
  components = c;
}
